const LanguageDetectionLanguageEventSource = 'languageDetection';
const AutomaticLanguageDetectionLikelyWrongId = 'automaticlanguagedetection.likelywrong';
const LanguageDetectionStatsId = 'automaticlanguagedetection.stats';
export { AutomaticLanguageDetectionLikelyWrongId, LanguageDetectionLanguageEventSource, LanguageDetectionStatsId };
